/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.2
 * @since 1.13.2
 */

import { useEffect } from 'react';

import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { Dispatch } from 'redux';

import { authUnauthorizedAction } from '../../pages/PageAuth/actions/authActions';
import { RoutePath } from '../constants/routesConstants';

const UnauthorizedRoute = ({
                               unauthorized,
                           }: IDispatchProps) => {

    useEffect(() => {
        unauthorized();
    }, [unauthorized]);

    return <Redirect to={RoutePath.login}/>;
};

export interface IDispatchProps {
    unauthorized: () => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    unauthorized: () => dispatch(authUnauthorizedAction()),
});

export default connect(null, mapDispatchToProps)(UnauthorizedRoute);
